import BN from 'bn.js';

import { wallet } from './wallet';

export const getLatestBlock = async () => {
  await wallet.initialize();
  return wallet.near.connection.provider.block({ finality: 'final' });
};

export const getLatestGasPrice = async () => {
  const latestBlock = await getLatestBlock();
  return latestBlock.header.gas_price;
};

export const getTotalGasFee = async (gas) => {
  const latestGasPrice = await getLatestGasPrice();
  return new BN(latestGasPrice).mul(new BN(gas)).toString();
};
